import { getDistance } from "geolib";
import { postcodeValidator, postcodeValidatorExistsForCountry } from "postcode-validator";
export const getGeoDistance = (lat1, lon1, lat2, lon2) => {
    // Guard against null or undefined values
    if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) {
        throw new Error("Cannot calculate distance: one or more coordinates are null or undefined");
    }
    return (getDistance({ latitude: lat1, longitude: lon1 }, { latitude: lat2, longitude: lon2 }) / 1000);
};
/**
 * Validates if the distance between two geographic points is within a maximum distance.
 * Returns true if the distance is within the maximum, or if any required parameters are missing (graceful degradation).
 * @param maxDistance - Maximum allowed distance in kilometers
 * @param lat1 - Latitude of first point
 * @param lon1 - Longitude of first point
 * @param lat2 - Latitude of second point
 * @param lon2 - Longitude of second point
 * @returns true if distance is within maxDistance or if any parameters are missing
 */
export const isValidDistance = (maxDistance, lat1, lon1, lat2, lon2) => {
    // Check for both null and undefined, and ensure values are valid numbers
    if (maxDistance != null &&
        lat1 != null &&
        lon1 != null &&
        lat2 != null &&
        lon2 != null &&
        typeof lat1 === "number" &&
        typeof lon1 === "number" &&
        typeof lat2 === "number" &&
        typeof lon2 === "number" &&
        !isNaN(lat1) &&
        !isNaN(lon1) &&
        !isNaN(lat2) &&
        !isNaN(lon2)) {
        try {
            return maxDistance >= getGeoDistance(lat1, lon1, lat2, lon2);
        }
        catch (error) {
            // If distance calculation fails, gracefully return true (assume valid)
            console.warn("Error calculating distance, assuming valid:", error);
            return true;
        }
    }
    return true;
};
export const validatePostCode = (country, postCode) => {
    if (postcodeValidatorExistsForCountry(country)) {
        const valid = postcodeValidator(postCode, country);
        return valid;
    }
    return false;
};
export const getIsWithinRadiusFirst = async (employee, project, maxDistance) => {
    if (project.projectAddress.geoLocationLat &&
        project.projectAddress.geoLocationLong &&
        employee.geoLocationLat &&
        employee.geoLocationLong) {
        const distance = getGeoDistance(employee.geoLocationLat, employee.geoLocationLong, project.projectAddress.geoLocationLat, project.projectAddress.geoLocationLong);
        return {
            distance: distance,
            withInRadius: distance < maxDistance
        };
    }
    return { distance: 100000, withInRadius: false };
};
